import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Package, MapPin, Heart, User, LogOut, Star } from 'lucide-react';
import { Button } from '../../components/ui/button';

const AccountLayout = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    navigate('/');
    window.location.reload();
  };

  const menuItems = [
    { path: '/account', label: t('account.dashboard'), icon: LayoutDashboard },
    { path: '/account/orders', label: t('account.orders'), icon: Package },
    { path: '/account/reviews', label: t('account.myReviews'), icon: Star },
    { path: '/account/addresses', label: t('account.addresses'), icon: MapPin },
    { path: '/account/wishlist', label: t('account.wishlist'), icon: Heart },
    { path: '/account/profile', label: t('account.profile'), icon: User },
  ];

  const isActive = (path) => {
    if (path === '/account') {
      return location.pathname === '/account';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-serif text-[#2C2420] mb-8">{t('account.myAccount')}</h1>
        
        <div className="grid md:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="md:col-span-1">
            <div className="bg-white rounded-lg shadow-md p-6">
              <nav className="space-y-2">
                {menuItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                        isActive(item.path)
                          ? 'bg-[#FAF8F5] text-[#be1f1a] font-medium'
                          : 'text-gray-700 hover:bg-gray-50'
                      }`}
                    >
                      <Icon className="h-5 w-5" />
                      {item.label}
                    </Link>
                  );
                })}
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors w-full"
                >
                  <LogOut className="h-5 w-5" />
                  {t('account.logout')}
                </button>
              </nav>
            </div>
          </div>

          {/* Content */}
          <div className="md:col-span-3">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountLayout;